export default {
  submit: 'Invio',
  reset_form: 'Cancella',
  signin: 'Nuovo Account',
  login: 'Accedi',
  username: 'Nome utente',
  password: 'Password',
  remember_me: 'Ricordami',
  language: 'Lingua',
  english: 'English',
  italiano: 'Italiano',
  inizia: 'Accedi',
  NO: 'NO',
  SI: 'SI',
  Indietro: 'Indietro',
  indietro: 'indietro',
  Continua: 'Continua',
  Home: 'Home',
  'Benvenuti nel software guida per la scelta di pali e torri per illuminazione.': "Benvenuti nell'area riservata del sito Pali Campion.",
  'Il software consente di accedere al catalogo prodotti della ditta Campion, attraverso una comoda interfaccia di ricerca.':
    'Effettuando la registrazione gratuita, potrete accedere alla nostra webapp che vi guiderà nella scelta dei pali e torri più adeguati alle vostre esigenze, oltre a fornirvi accesso a tutte le specifiche tecniche dei nostri prodotti. In seguito alla registrazione, potreste essere contattati dal nostro venditore di zona.',
  'Sezioni principali': 'Sezioni principali',
  "Accedi all'applicazione": "Accedi all'applicazione",
  "Esci dall'applicazione": "Esci dall'applicazione",
  'guida introduttiva': 'guida introduttiva',
  'Ricerca pali': 'Ricerca pali',
  'ricerca e consultazione': 'ricerca e consultazione',
  'Ricerca palo': 'Ricerca palo',
  'Premere il pulsante "nuova ricerca" per iniziare.': 'Premere il pulsante "nuova ricerca" per iniziare.',
  'nuova ricerca': 'nuova ricerca',
  'Recupero ricerche precedenti...': 'Recupero ricerche precedenti...',
  'Ricerche precedenti': 'Ricerche precedenti',
  'Non hai ancora salvato nessuna ricerca.': 'Non hai ancora salvato nessuna ricerca.',
  'Cancellare la ricerca salvata': 'Cancellare la ricerca salvata',
  'Errore durante il recupero dei risultati: ': 'Errore durante il recupero dei risultati: ',
  'tipologia di palo': 'tipologia di palo',
  'Selezionare o modificare la tipologia di palo richiesta': 'Selezionare o modificare la tipologia di palo richiesta',
  'configurazione palo': 'configurazione palo',
  'Selezionare o modificare la configurazione di palo richiesto': 'Selezionare o modificare la configurazione di palo richiesto',
  caratteristiche: 'caratteristiche',
  'Seleziona le caratteristiche del palo.': 'Seleziona le caratteristiche del palo.',
  località: 'località',
  "Seleziona la località di installazione sulla mappa oppure inserisci l'indirizzo o le coordinate":
    "Seleziona la località di installazione sulla mappa oppure inserisci l'indirizzo o le coordinate",
  "Non è stato possibile recuperare le coordinate per l'indirizzo richiesto.":
    "Non è stato possibile recuperare le coordinate per l'indirizzo richiesto.",
  risultati: 'risultati',
  'Calcolo risultati.': 'Calcolo risultati.',
  'Tipologia di Palo': 'Tipologia di Palo',
  'Caricamento catalogo': 'Caricamento catalogo',
  ERRORE: 'ERRORE',
  'NON TROVATO': 'NON TROVATO',
  'Nessuna tipologia di palo disponibile': 'Nessuna tipologia di palo disponibile',
  'Errore durante il recupero delle tipologie di palo: ': 'Errore durante il recupero delle tipologie di palo: ',
  'Configurazione per': 'Configurazione per',
  'Altezza punto luce': 'Altezza punto luce',
  'Sporgenza punto luce': 'Sporgenza punto luce',
  'Superficie esposta di ogni apparecchio': 'Superficie esposta di ogni apparecchio',
  'Superficie esposta testapalo': 'Superficie totale esposta al vento in cima',
  'Superficie esposta sbraccio': 'Superficie esposta su ogni braccio',
  'Verifica idoneità strutturale con corpo illuminante stradale (0,05mq – 10kg) montato in cima':
    'Verifica idoneità strutturale con corpo illuminante stradale (0,05mq – 10kg) montato in cima',
  'Dovranno essere assunti i dati (superficie esposta, coefficienti di forma, peso) forniti dalle Ditte Costruttrici dei proiettori stessi.':
    'Dovranno essere assunti i dati (superficie esposta, coefficienti di forma, peso) forniti dalle Ditte Costruttrici dei proiettori stessi.',
  'In mancanza di dati specifici si applicheranno i seguenti:': 'In mancanza di dati specifici si applicheranno i seguenti:',
  'Armature stradali 0,2 m² cadauna': 'Armature stradali 0,2 m² cadauna',
  'Proiettori per illuminazione:': 'Proiettori per illuminazione:',
  Potenza: 'Potenza',
  larghezza: 'larghezza',
  altezza: 'altezza',
  Profondità: 'Profondità',
  'altezza tot.': 'altezza tot.',
  'Area exp.': 'Area exp.',
  'Geometria proiettori generici simmetrici': 'Geometria proiettori generici simmetrici',
  'Geometria proiettori generici asimmetrici': 'Geometria proiettori generici asimmetrici',
  'In casi generici:': 'In casi generici:',
  Caratteristiche: 'Caratteristiche',
  'Disposizione proiettori': 'Disposizione proiettori',
  'Potenza proiettori': 'Larghezza proiettori',
  'nessuna copertura': 'nessuna copertura',
  'con cupola o cappello': 'con cupola o cappello',
  'Numero proiettori': 'Numero proiettori',
  'Cupola/cappello': 'Cupola/cappello',
  Asimmetrici: 'Asimmetrici',
  Simmetrici: 'Simmetrici',
  'Verranno assunti i dati (superficie esposta, coefficienti di forma, peso) sulla base dei seguenti parametri:':
    'Verranno assunti i dati (superficie esposta, coefficienti di forma, peso) sulla base dei seguenti parametri:',
  'Superficie totale esposta al vento': 'Superficie totale esposta al vento',
  "sposta la mappa sul punto di installazione o scrivi l'indirizzo nel campo seguente":
    "sposta la mappa sul punto di installazione o scrivi l'indirizzo nel campo seguente",
  'Località di installazione': 'Località di installazione',
  indirizzo: 'indirizzo',
  esposizione: 'esposizione',
  terreno: 'terreno',
  collocazione: 'collocazione',
  'I valori sono impostati automaticamente spostando il punto sulla mappa e possono essere modificati prima di procedere.':
    'I valori sono impostati automaticamente spostando il punto sulla mappa e possono essere modificati prima di procedere.',
  quota: 'quota',
  'distanza dal mare': 'distanza dal mare',
  'velocità del vento reale a 10m dal piano campagna': 'velocità del vento reale a 10m dal piano campagna',
  'Mare, oltre 2Km di distanza dalla costa': 'Mare, oltre 2Km di distanza dalla costa',
  'Mare, entro 2Km di distanza  dalla costa': 'Mare, entro 2Km di distanza  dalla costa',
  'Mare, entro 500m di distanza  dalla costa': 'Mare, entro 500m di distanza  dalla costa',
  'Entroterra, entro 10Km di distanza dalla costa': 'Entroterra, entro 10Km di distanza dalla costa',
  'Entroterra, entro 40Km di distanza dalla costa': 'Entroterra, entro 40Km di distanza dalla costa',
  'Entroterra, oltre 40Km di distanza dalla costa': 'Entroterra, oltre 40Km di distanza dalla costa',
  "Valle d'Aosta, Piemonte, Lombardia, Trentino-Alto Adige, Veneto, Friuli Venezia-Giulia (esclusa provincia di Trieste)":
    "Valle d'Aosta, Piemonte, Lombardia, Trentino-Alto Adige, Veneto, Friuli Venezia-Giulia (esclusa provincia di Trieste)",
  'Toscana, Marche, Umbria, Lazio, Abruzzo, Molise, Campania, Puglia, Basilicata, Calabria (esclusa provincia di Reggio Calabria)':
    'Toscana, Marche, Umbria, Lazio, Abruzzo, Molise, Campania, Puglia, Basilicata, Calabria (esclusa provincia di Reggio Calabria)',
  'Sicilia e provincia di Reggio Calabria': 'Sicilia e provincia di Reggio Calabria',
  "Sardegna (zona a oriente della retta congiungente Capo Teulada con l'Isola della Maddalena)":
    "Sardegna (zona a oriente della retta congiungente Capo Teulada con l'Isola della Maddalena)",
  "Sardegna (zona a occidente della retta congiungente Capo Teulada con l'Isola della Maddalena)":
    "Sardegna (zona a occidente della retta congiungente Capo Teulada con l'Isola della Maddalena)",
  'Provincia di Trieste': 'Provincia di Trieste',
  "Isole (con l'eccezione di Sicilia e Sardegna) e mare aperto": "Isole (con l'eccezione di Sicilia e Sardegna) e mare aperto",
  Zona: 'Zona',
  'inferiore a 500m s.l.m.': 'inferiore a 500m s.l.m.',
  'tra i 500m e i 750m s.l.m.': 'tra i 500m e i 750m s.l.m.',
  'tra i 750m e i 1000m s.l.m.': 'tra i 750m e i 1000m s.l.m.',
  'tra i 1000m e i 1500m s.l.m.': 'tra i 1000m e i 1500m s.l.m.',
  'oltre i 1500m s.l.m.': 'oltre i 1500m s.l.m.',
  'zona di ventosità': 'zona di ventosità',
  "L'assegnazione della classe di rugosità non dipende dalla conformazione orografica e topografica del terreno. Affinchè una costruzione possa dirsi ubicata nelle prime due classi è necessario che la situazione che contraddistingue la classe permanga intorno alla costruzione per non meno di 1 km e comunque non meno di 20 volte l'altezza dell'edificio. Laddove sussistano dubbi sulla scelta della classe, a meno di analisi rigorose, verrà assegnata la classe più sfavorevole.":
    "L'assegnazione della classe di rugosità non dipende dalla conformazione orografica e topografica del terreno. Affinchè una costruzione possa dirsi ubicata nelle prime due classi è necessario che la situazione che contraddistingue la classe permanga intorno alla costruzione per non meno di 1 km e comunque non meno di 20 volte l'altezza dell'edificio. Laddove sussistano dubbi sulla scelta della classe, a meno di analisi rigorose, verrà assegnata la classe più sfavorevole.",
  'Aree urbane in cui almeno il 15% della superficie è coperto da edifici con altezza media maggiore di 15 metri.':
    'Aree urbane in cui almeno il 15% della superficie è coperto da edifici con altezza media maggiore di 15 metri.',
  'Aree suburbane o industriali e foreste permanenti.': 'Aree suburbane o industriali e foreste permanenti.',
  'Terreni coltivati cintati da siepi, qualche piccola costruzione agricola, case o alberi.':
    'Terreni coltivati cintati da siepi, qualche piccola costruzione agricola, case o alberi.',
  'Costa marina. Costa di lago con lunghezza sopravvento di almeno 5 Km. Terreno piano, senza ostacoli.':
    'Costa marina. Costa di lago con lunghezza sopravvento di almeno 5 Km. Terreno piano, senza ostacoli.',
  'Scegli la categoria di rugosità del terreno': 'Scegli la categoria di rugosità del terreno',

  Ricerca: 'Ricerca',
  'Ricerca in corso': 'Ricerca in corso',
  'Sono state individuate': 'Sono state individuate',
  'torri corrispondenti ai parametri di ricerca:': 'torri corrispondenti ai parametri di ricerca:',
  'Sono stati individuati': 'Sono stati individuati',
  'pali corrispondenti ai parametri di ricerca:': 'pali corrispondenti ai parametri di ricerca:',
  'È stata individuata': 'È stata individuata',
  'torre corrispondente ai parametri di ricerca:': 'torre corrispondente ai parametri di ricerca:',
  'È stato individuato': 'È stato individuato',
  'palo corrispondente ai parametri di ricerca:': 'palo corrispondente ai parametri di ricerca:',
  Palo: 'Palo',
  'con sbraccio': 'con sbraccio',
  'con piattaforma': 'con piattaforma',
  'con paranco manuale': 'con paranco manuale',
  'con paranco elettrico': 'con paranco elettrico',
  'Errore:': 'Errore:',
  'Nessun palo corrisponde alle caratteristiche indicate.': 'Nessun palo standardizzato corrisponde alle caratteristiche indicate.',
  'Puoi inviare la richiesta al nostro ufficio tecnico, per una progettazione dedicata':
    'Puoi inviare la richiesta al nostro ufficio tecnico, per una progettazione dedicata',
  'Parametri inseriti:': 'Parametri inseriti:',
  "Errore nell'invio della richiesta": "Errore nell'invio della richiesta",
  'Tipologia di palo': 'Tipologia di palo',
  Configurazione: 'Configurazione',
  'Zona di ventosità': 'Zona di ventosità',
  'Posizione geografica': 'Posizione geografica',
  'Categoria di esposizione': 'Categoria di esposizione',
  'Calcolo in corso...': 'Calcolo in corso...',
  'Velocità del vento da progetto': 'Velocità del vento da progetto',
  'Classe di esposizione EN 40-3-1': 'Classe di esposizione EN 40-3-1',
  'Velocità V': 'Velocità V',
  Sporgenza: 'Sporgenza',
  Proiettori: 'Proiettori',
  Orientazione: 'Disposizione',
  'Superficie esposta': 'Superficie esposta',
  'Salva ricerca': 'Salva ricerca',
  'Nuova ricerca': 'Nuova ricerca',
  'Errore nel salvataggio': 'Errore nel salvataggio',
  'Impossibile salvare la ricerca.': 'Impossibile salvare la ricerca.',
  'Causa:': 'Causa:',
  'Salva ricerca con nome': 'Salva ricerca con nome',
  'Inserire un nome': 'Inserire un nome',
  Annulla: 'Annulla',
  Salva: 'Salva',
  Invia: 'Invia',
  Torre: 'Torre',
  'proiettori aventi larghezza': 'proiettori aventi larghezza: ',
  'proiettore avente larghezza': 'proiettore avente larghezza: ',
  'Superficie proiettori': 'Superficie esposta al vento di un proiettore',
  ', con cupola o cappello': ', con cupola o cappello',
  peso: 'peso',
  Esempi_configurazione: 'Esempi di configurazione per ',
  Testapalo: 'Testapalo',
  'Sbraccio singolo': 'Sbraccio singolo',
  'Sbraccio doppio': 'Sbraccio doppio',
  '3 o 4 bracci': '3 o 4 bracci',
  'Torre ascensionale': 'Torre ascensionale',
  'Torre con scala e piattaforma': 'Torre con scala e piattaforma',
  dati_assunti:
    'Dovranno essere assunti i dati (superficie esposta, coefficienti di forma, peso) forniti dalle Ditte Costruttrici dei proiettori stessi. In mancanza di dati specifici si applicheranno i seguenti:',
  'Peso di un proiettore': 'Peso di un proiettore',
  'Classe di rugosità del terreno': 'Classe di rugosità del terreno',
  'Usare massimo 50 caratteri': 'Usare massimo 150 caratteri',
  'Usare massimo 500 caratteri': 'Usare massimo 500 caratteri',
  'Pali a sicurezza passiva': 'Pali a sicurezza passiva',
  'Pali per illuminazione': 'Pali per illuminazione',
  'Torri portafari': 'Torri portafari',
  'Messaggio (opzionale). I dati della ricerca saranno inseriti automaticamente':
    'Messaggio (opzionale). I dati della ricerca saranno inseriti automaticamente',
  "Errore nell'invio della richiesta.": "Errore nell'invio della richiesta.",
  Esempi: 'Esempi',
  'Email non valida': 'Email non valida',
  Fax: 'Fax',
  Telefono: 'Telefono',
  Cellulare: 'Recapito telefonico',
  Stato: 'Stato',
  Provincia: 'Provincia',
  Localita: 'Città',
  CAP: 'CAP',
  Indirizzo: 'Indirizzo',
  'Ragione sociale': 'Ragione sociale',
  username_signin: 'Nome utente (da usare per accedere)',
  Email: 'e-mail',
  Nome: 'Nome',
  Password: 'Password',
  'E-mail': 'E-mail',
  Cognome: 'Cognome',
  'Sito internet': 'Sito Internet',
  'Password (ripetere)': 'Password (ripetere)',
  'email richiesta': "Manca l'email",
  richiesto: 'Questo campo è richiesto',
  'non corrispondono': 'Le due password non coincidono',
  privacy: 'Accetto la privacy policy',
  'maggiori informazioni': 'maggiori informazioni',
  'privacy richiesta': 'È necessario accettare la privacy policy',
  'Messaggio inviato con successo.': 'Messaggio inviato con successo',
  'Tipo utente': 'Tipo utente',
  Rivenditore: 'Rivenditore',
  Installatore: 'Installatore',
  'Impresa Costruzioni': 'Impresa Costruzioni',
  'Azienda utilizzatrice': 'Azienda utilizzatrice',
  Ente: 'Ente',
  'Studio Progettazione': 'Studio Progettazione',
  'Agente di commercio': 'Agente di commercio',
  Privato: 'Privato',
  'Area download': 'Download area',
  'Clicca sul nome del prodotto per scaricare le schede tecniche (File: doc, dwg, pdf).':
    'Clicca sul nome del prodotto per scaricare le schede tecniche (File: doc, dwg, pdf).',
  'PORTATE PALI STANDARD': 'PORTATE PALI STANDARD',
  'FONDAZIONI PALI STANDARD': 'FONDAZIONI PALI STANDARD',
  'Database contenente i limiti di portata':
    'Database contenente i limiti di portata di tutti i pali standard, nelle varie zone di ventosità previste dalla normativa.',
  'Per leggere il file è necessario Microsoft Excel, di comune utilizzo nella stragrande maggioranza dei pc':
    'Per leggere il file è necessario Microsoft Excel, di comune utilizzo nella stragrande maggioranza dei pc',
  'Database contenente le dimensioni minime delle fondazione necessarie per i pali standard.':
    'Database contenente le dimensioni minime delle fondazione necessarie per i pali standard.',
  'TORRI A CORONA MOBILE': 'TORRI A CORONA MOBILE',
  'TORRI A PANNELLO MOBILE': 'TORRI A PANNELLO MOBILE',
  'TORRI CON SCALA E PIATTAFORMA': 'TORRI CON SCALA E PIATTAFORMA',
  MONTAGGI: 'MONTAGGI',
  'PALI CONICI': 'PALI CONICI',
  'PALI RASTREMATI': 'PALI RASTREMATI',
  'PALI OTTAGONALI E POLIGONALI': 'PALI OTTAGONALI E POLIGONALI',
  'PALI COMPONIBILI CAMPIONLIGHT': 'PALI COMPONIBILI CAMPIONLIGHT',
  'LAVORAZIONI A RICHIESTA': 'LAVORAZIONI A RICHIESTA',
  'SBRACCI E TRAVERSE ACCESSORI PER PALI DRITTI': 'SBRACCI E TRAVERSE ACCESSORI PER PALI DRITTI',
  'PALI BASCULANTI RIBALTABILI': 'PALI BASCULANTI RIBALTABILI',
  'PALI PER LINEE AEREE UNIFICAZIONE ENEL': 'PALI PER LINEE AEREE UNIFICAZIONE ENEL',
  'PALI SEMAFORICI': 'PALI SEMAFORICI',
  'PALI DECORATIVI ARREDO URBANO': 'PALI DECORATIVI ARREDO URBANO',
  'SISTEMA SAVE A SICUREZZA PASSIVA': 'SISTEMA SAVE A SICUREZZA PASSIVA',
  'PALI CONICI DRITTI': 'PALI CONICI DRITTI',
  'PALI CONICI CURVATI': 'PALI CONICI CURVATI',
  'Sbracci cilindrici ricurvi': 'Sbracci cilindrici ricurvi',
  'Sbracci a squadro': 'Sbracci a squadro',
  'Attacchi a pipa': 'Attacchi a pipa',
  'Traverse portaproiettori': 'Traverse portaproiettori',
  'Kit fotovoltaico': 'Kit fotovoltaico',
  'SCHEDE TECNICHE': 'SCHEDE TECNICHE',
  'cerca tra i documenti': 'cerca tra i documenti',
  'schede tecniche prodotti, fondazioni, portate': 'Schede tecniche prodotti, fondazioni, portate',
  'Tiro massimo di progetto': 'Tiro massimo di progetto',
  descrizione_tiro_max_progetto:
    "tiro teorico di collasso, applicato in cima al palo, che da luogo ad un diagramma dei momenti flettenti che approssima, a favore di sicurezza(coefficiente 2, CEI 11- 4), il diagramma dei momenti flettenti derivanti dall'azione complessiva dovuta ai conduttori e alla spinta del vento distribuita lungo il palo.",
  Lunghezza: 'Lunghezza',
  'Visualizza su google maps': 'Visualizza su google maps',
  'Coordinate di installazione': 'Coordinate di installazione',
  // da qui
  tiro: 'Tiro',
  Altezza: 'Altezza',
  direzione: 'Direzione',
  Direzione: 'Direzione',
  'Quota di applicazione': 'Quota di applicazione',
  sbraccio: 'Sbraccio',
  Sbraccio: 'Sbraccio',
  'carico orizzontale': 'carico orizzontale',
  'carico verticale': 'carico verticale',
  'Nessun carico presente.': 'Nessun carico presente.',
  'Aggiungi carico': 'Aggiungi carico',
  'Campo obbligatorio': 'Campo obbligatorio',
  'Nessun dato inserito. Aggiungi una riga': 'Nessun dato inserito. Aggiungi una riga',
  'Albero dei carichi': 'Albero dei carichi',
  'Schema disposizione mensole': 'Schema disposizione mensole',
  'Inserire un valore numerico': 'Inserire un valore numerico',

  'Inserire un valore maggiore di 0': 'Inserire un valore maggiore di 0',
  'Riepilogo e invio email per dimensionamento ': 'Riepilogo e invio email per dimensionamento ',
  'Eventuali annotazioni': 'Eventuali annotazioni',
  'Premere il pulsante': 'Premere il pulsante',
  INVIA: 'INVIA',
  'per trasmettere una richiesta al nostro ufficio tecnico, per una progettazione dedicata.':
    'per trasmettere una richiesta al nostro ufficio tecnico, per una progettazione dedicata.',
  'Salva bozza ricerca': 'Salva bozza ricerca',
  'Messaggio (opzionale)': 'Messaggio (opzionale)',
  'Interdistanza tra i pali (campata)': 'Interdistanza tra i pali (campata)',
  'Diametro del cavo': 'Diametro del cavo',
  'Peso del cavo': 'Peso del cavo',
  'Fune di sostegno': 'Fune di sostegno',
  'Diametro fune': 'Diametro fune',
  'Peso fune': 'Peso fune',
  'Posizione sostegno': 'Posizione sostegno',
  rettifilo: 'rettifilo',
  angolo: 'angolo',
  capolinea: 'capolinea',
  Presente: 'Presente',
  'La richiesta sarà salvata automaticamente.': 'La richiesta sarà salvata automaticamente.',
  'Bozza salvata': 'Bozza salvata',
  'Torna al riepilogo': 'Torna al riepilogo',
  'Ancoraggio base': 'Ancoraggio base',
  'infissione diretta': 'infissione diretta',
  'piastra base e tirafondi': 'piastra base e tirafondi',
  Scala: 'Scala',
  'Descrizione Pale e rotore/Navicella': 'Descrizione Pale e rotore/Navicella',
  'È necessario indicare le dimensioni, il peso e la frequenza naturale di vibrazione.':
    'È necessario indicare le dimensioni, il peso e la frequenza naturale di vibrazione.',
  Allegati: 'Allegati',
  'Carica allegato': 'Carica allegato',
  'File presenti': 'File presenti',
  'Rastrelliera esterna porta cavi': 'Rastrelliera esterna porta cavi',
  Piattaforma: 'Piattaforma',
  'Limite oscillazione in cima': 'Limite oscillazione in cima',
  'Velocità del vento per verifica dello spostamento in cima': 'Velocità del vento per verifica dello spostamento in cima',
  'Spostamento massimo': 'Spostamento massimo',
  'Descrizione antenne': 'Descrizione antenne',
  'È necessario indicare le dimensioni, il peso e la disposizione degli apparati da installare.':
    'È necessario indicare le dimensioni, il peso e la disposizione degli apparati da installare.',
  Modello: 'Modello',
  'a bandiera': 'a bandiera',
  'a farfalla': 'a farfalla',
  'a cavalletto': 'a cavalletto',
  pedonale: 'pedonale',
  'Descrizione segnaletica': 'Descrizione segnaletica',
  'È necessario indicare le dimensioni, il peso e la posizione della segnaletica.':
    'È necessario indicare le dimensioni, il peso e la posizione della segnaletica.',
  'Sporgenza bracci': 'Sporgenza bracci',
  'Superficie esposta al vento (lanterne e pannello contrasto)': 'Superficie esposta al vento (lanterne e pannello contrasto)',
  'Sup.Tot.': 'Sup.Tot.',
  'Sostegno portainsegna': 'Sostegno portainsegna',
  'normalmente con altezze da 15 a 25 metri': 'normalmente con altezze da 15 a 25 metri',
  'normalmente con altezze da 20 a 30 metri': 'normalmente con altezze da 20 a 30 metri',
  'Torre portainsegna con piattaforma': 'Torre portainsegna con piattaforma',
  'Torre portainsegna luminosa': 'Torre portainsegna luminosa',
  'a movimentazione motorizzata fino a 1000Kg': 'a movimentazione motorizzata fino a 1000Kg',
  'normalmente con altezze da 20 a 35 metri': 'normalmente con altezze da 20 a 35 metri',
  'Descrizione insegna': 'Descrizione insegna',
  "È necessario indicare le dimensioni, il peso e la disposizione dell'insegna.":
    "È necessario indicare le dimensioni, il peso e la disposizione dell'insegna.",
  'Palo alzabandiera': 'Palo alzabandiera',
  'Palo con braccio rotante per stendardo': 'Palo con braccio rotante per stendardo',
  'Torre alzabandiera': 'Torre alzabandiera',
  'Altezza bandiera': 'Altezza bandiera',
  'Larghezza bandiera': 'Larghezza bandiera',
  'Distanza tra i pali': 'Distanza tra i pali',
  'Descrizione della rete': 'Descrizione della rete',
  'È necessario indicare le dimensioni della maglia e del filo.': 'È necessario indicare le dimensioni della maglia e del filo.',
  'Descrizione degli apparati': 'Descrizione degli apparati',
  'È necessario indicare le dimensioni, i pesi, la disposizione degli apparati, delle telecamere, delle antenne wifi e delle cassette di derivazione.':
    'È necessario indicare le dimensioni, i pesi, la disposizione degli apparati, delle telecamere, delle antenne wifi e delle cassette di derivazione.',
  'Sporgenza di un braccio': 'Sporgenza di un braccio',
  Campata: 'Campata',
  Visualizza: 'Visualizza',
  'Torna al sito': 'Torna al sito',
  'Torna al sito palicampion.it': 'Torna al sito palicampion.it',
  "Esci dall'area riservata": "Esci dall'area riservata",
  'Pali ENEL DS3010': 'Pali ENEL DS3010',
  'Pali ENEL DS3012': 'Pali ENEL DS3012',
  'Sostegni per elettrodotti': 'Sostegni per elettrodotti',
  'Pali con linea in cavo aereo': 'Pali con linea in cavo aereo',
  'Pali per linee MT-BT unificati ENEL': 'Pali per linee MT-BT unificati ENEL',
  'Pali per videosorveglianza': 'Pali per videosorveglianza',
  'Pali per recinzioni':'Pali per recinzioni',
  'Pali portabandiera':'Pali portabandiera',
  'Pali portainsegna': 'Pali portainsegna',
  'Pali semaforici': 'Pali semaforici',
  'Pali per segnaletica': 'Pali per segnaletica',
  'Pali per telecomunicazioni': 'Pali per telecomunicazioni',
  'Pali Eolici': 'Pali eolici',
  'Pali linee aeree': 'Pali linee aeree'

}
